// extracted by mini-css-extract-plugin
export default {"elements":"ReportLeftSidebar_elements__iKYqM","imgUrl":"ReportLeftSidebar_imgUrl__jPzc9","leftSidebar":"ReportLeftSidebar_leftSidebar__GY6ic"};